import { render, staticRenderFns } from "./FooterPanel.vue?vue&type=template&id=18b4fd70&scoped=true&"
import script from "./FooterPanel.vue?vue&type=script&lang=ts&"
export * from "./FooterPanel.vue?vue&type=script&lang=ts&"
import style0 from "./FooterPanel.vue?vue&type=style&index=0&id=18b4fd70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4fd70",
  null
  
)

export default component.exports